import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import { dashedUserLocale } from 'app/features/user/selectors';
import { LATEST_NEWS_LIMIT, TOP_NEWS_LIMIT } from 'app/features/news/constants';
import { LATEST_NEWS_FETCHED } from 'app/features/news/actionTypes';

const latestNewsFetched = createAction(LATEST_NEWS_FETCHED);

function fetchLatestNews() {
  return (dispatch, getState, { api }) =>
    api
      .fetchLatestNews({
        top: TOP_NEWS_LIMIT,
        latest: LATEST_NEWS_LIMIT,
        locale: dashedUserLocale(getState()),
      })
      .then(compose(dispatch, latestNewsFetched));
}

export { fetchLatestNews };
